import { TranslateService } from "@ngx-translate/core";
import { UserContext } from "../../../../common";
import { MenuItem } from "../../../../views/layout/sidebar/menu.model";
import { CompanyManagementPermissions } from "../../permissions";

export const getCompanyManagementMenu: (
  userContext?: UserContext,
  translate?: TranslateService
) => MenuItem[] = (userContext?: UserContext, translate?: TranslateService) => {
  const hasAccessToCompanyManagement =
      userContext?.hasPermission(CompanyManagementPermissions.Companies.ReadAll);
  return [
    {
      id: 13,
      label: translate ? translate.instant('MENUS.COMPANIES') : 'Companies',
      isHidden: !hasAccessToCompanyManagement,
      icon: 'pi pi-building',
      expanded: true,
      link: `companies-management/companies`,
    }
  ];
};
